import { useState, useRef, useEffect } from "react";
import Webcam from "react-webcam";
import { hostName } from "../config/config";
import ConfirmationPopup from "./common/ConfirmationPopup";

function MiniCapture({ isView, savedImages, fieldValue, formData, onImagesChange, onResetChange,
  onHandleActionFieldsChange, onImageDelete, reset, mandatoryFieldRef }) {
  const [showCamera, setShowCamera] = useState(false);
  const [capturedImages, setCapturedImages] = useState([]);
  const [hideRemediation, setHideRemediation] = useState(false);
  const [facingMode, setFacingMode] = useState("user");
  const webcamRef = useRef(null);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState({
    show: false,
    itemIndex: 0,
  });
  const fieldComm = fieldValue + "Comments";
  const fieldSev = fieldValue + "Severity";
  const fieldCat = fieldValue + "Category";
  const fieldDue = fieldValue + "DueDate";
  const fieldRemed = fieldValue + "Remediation";
  const fieldFile = fieldValue + "File";

  const ImageProxyBaseUrl = hostName + "/api/Inspection/api/image?blobUrl=";


  // const fds = fieldValue+"Predefined";

  useEffect(() => {
    if (reset) {
      setCapturedImages([]);
      onImagesChange([], "");
    }
    if (savedImages) {
      setCapturedImages(savedImages);
    }
    if(formData[fieldCat] === "5"){
      setHideRemediation(true);
    }else{
      setHideRemediation(false);
    }
  }, [reset]);

  const videoConstraints = {
    width: 640,
    height: 480,
    facingMode: facingMode,
  };

  const updateImages = (newImages) => {
    setCapturedImages(newImages);
    if (onImagesChange) {
      onImagesChange(newImages);
    }
  };

  const deleteImages = (newImages, index) => {
    setCapturedImages(newImages);
    if (onImageDelete) {
      onImageDelete(index);
    }
  };

  const capturePhoto = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc) {
      const newImages = [...capturedImages, imageSrc];
      updateImages(newImages);
      setShowCamera(false);
    }
  };

  const switchCamera = () => {
    setFacingMode((prev) => (prev === "user" ? "environment" : "user"));
  };

  const removeImage = (indexToRemove) => {
    const newImages = capturedImages.filter(
      (_, index) => index !== indexToRemove
    );
    if (mandatoryFieldRef.current[fieldValue]) {
        mandatoryFieldRef.current[fieldValue].value = "";
      }
    deleteImages(newImages, indexToRemove);
     setShowConfirmationPopup(
      {
        show: false,
        itemIndex: 0
      }
    )
  };

  const closeCamera = () => {
    setShowCamera(false);
  }
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const newImages = [...capturedImages, reader.result];
        updateImages(newImages);
      };
      reader.readAsDataURL(file);
    }
  };
  const triggerFileInput = () => {
    // document.getElementById("fileInput").click();
    mandatoryFieldRef.current[fieldFile].click();
  };

  const handleReset = () => {
    setCapturedImages([]);
    onImagesChange([], "");
    onResetChange();
  };
  const resetIndvidualField = (field) => {
    mandatoryFieldRef.current[field] != null ?
        mandatoryFieldRef.current[field].style.border = "1px solid #dee2e6" : null;
  }
  const checkCategory = (e) => {
    if(e.target.value === "5"){
      setHideRemediation(true);
    }else{
      setHideRemediation(false);
    }
    onHandleActionFieldsChange(e, "Category")
  }

   const closePopup = () => {
    setShowConfirmationPopup(
      {
        show: false,
        itemIndex: 0
      }
    )
  }


  return (
    <div>
      <div className="d-flex gap-3 flex-wrap pb-2">
        <ConfirmationPopup
        show={showConfirmationPopup.show}
        headingText="Delete Image"
        infoText="Please confirm if you want to delete the selected image"
        cancelText="Cancel"
        submitText="Delete"
        onCancel={() => { closePopup() }}
        onSubmit={() => {
          removeImage(
            showConfirmationPopup.itemIndex,
          )
        }}
      />
        {/* <input
                      type="text"
                      className="form-control"
                      id="timelines"
                      name="timelines"
                      disabled
                      placeholder=""  
                      value={formData[fds]}
                      style={{marginTop:"1px",height:"60px",marginBottom:"-8px"}}
                    /> */}
        {/*<div className="form-floating flex-grow-1">
           <select
            className="form-select"
            ref={(el) => (mandatoryFieldRef.current[fieldtime] = el)}
            name={fieldValue}
            disabled={isView}
            aria-label="Floating label select example"
            value={formData[fieldtime]}
            onChange={(e) => {
              resetIndvidualField(fieldtime);
              onHandleActionFieldsChange(e, "Timeline");
            }}
          >
            <option selected>Select</option>
            <option value="1">Long Term</option>
            <option value="2">Medium Term</option>
            <option value="3">Short term</option>
          </select> 
          <label htmlFor="floatingSelect">
            Timeline<span style={{ color: "red" }}>*</span>
          </label> 
        </div>*/}
        <div className="form-floating flex-grow-1">
          <select
            className="form-select"
            id="floatingSelect"
            name={fieldValue}
            disabled={isView}
            aria-label="Floating label select example"
            value={formData[fieldSev]}
            ref={(el) => (mandatoryFieldRef.current[fieldSev] = el)}
            onChange={(e) => {
              resetIndvidualField(fieldSev);
              onHandleActionFieldsChange(e, "Severity");
            }}
          >
            <option selected>Select</option>
            <option value="1">Critical</option>
            <option value="2">High</option>
            <option value="3">Medium</option>
            <option value="4">Low</option>
          </select>
          <label htmlFor="floatingSelect">
            Severity<span style={{ color: "red" }}>*</span>
          </label>
        </div>
      </div>
      <div className="d-flex gap-3 flex-wrap pb-2">
        <div className="form-floating flex-grow-1">
          <select
            className="form-select"
            id="floatingSelect"
            name={fieldValue}
            disabled={isView}
            ref={(el) => (mandatoryFieldRef.current[fieldCat] = el)}
            aria-label="Floating label select example"
            value={formData[fieldCat]}
            onChange={(e) => { resetIndvidualField(fieldCat); checkCategory(e) }}
          >
            <option selected>Select</option>
            <option value="1">Firedoor Repair</option>
            <option value="2">Signage repair</option>
            <option value="3">Fire door Replacement</option>
            <option value="4">Testing, Records, Log Book</option>
            <option value="5">Door Replacement required</option>
            <option value="6">Door Repair</option>
          </select>
          <label htmlFor="floatingSelect">Category<span style={{ color: 'red' }}>*</span></label>
        </div>
        <div className="form-floating flex-grow-1">
          <input
            type="date"
            className="form-control"
            id="duedate"
            name={fieldValue}
            disabled
            value={formData[fieldDue]}
            ref={(el) => (mandatoryFieldRef.current[fieldDue] = el)}
            onChange={(e) => {resetIndvidualField(fieldDue); onHandleActionFieldsChange(e, "DueDate")}}
          />
          <label htmlFor="duedate">Due Date<span style={{ color: 'red' }}>*</span></label>
        </div>
      </div>
      {!hideRemediation && <div className="d-flex gap-3 flex-wrap pb-2">
        <div className="form-floating flex-grow-1">
          <textarea
            rows={4}
            type="text"
            className="form-control"
            id="remediation"
            style={{ minHeight: "auto", height: "auto" }}
            name={fieldValue}
            disabled={isView}
            placeholder="Remedial/Action required"
            value={formData[fieldRemed]}
            ref={(el) => (mandatoryFieldRef.current[fieldRemed] = el)}
            onChange={(e) => {resetIndvidualField(fieldRemed); onHandleActionFieldsChange(e, "Remediation")}}
          />
          <label htmlFor="remediation">
            Remedial/Action required<span style={{ color: 'red' }}>*</span>
          </label>
        </div>
      </div>}
      {fieldValue === "visualDefectsToDoor" && (<div className="form-floating flex-grow-1 pb-2">
        <select
          className="form-select"
          id="floatingSelect"
          name={fieldValue}
          disabled={isView}
          ref={(el) => (mandatoryFieldRef.current.visualDefectsToDoorDamageType = el)}
          aria-label="Floating label select example"
          value={formData.visualDefectsToDoorDamageType}
          onChange={(e) => { resetIndvidualField("visualDefectsToDoorDamageType"); onHandleActionFieldsChange(e, "DamageType") }}
        >
          <option selected>Select</option>
          <option value="Missing Screws">Missing Screws</option>
          <option value="Leaking Hinges">Leaking Hinges</option>
          <option value = "Damaged/Defective Handle">Damaged/Defective Handle</option>
        </select>
        <label htmlFor="floatingSelect">Damage Type<span style={{ color: 'red' }}>*</span></label>
      </div>)}
      <div className="form-floating pb-2">
        <textarea
          className="form-control"
          rows="4"
          name={fieldValue}
          disabled={isView}
          style={{ minHeight: "auto", height: "auto" }}
          placeholder="Comments"
          value={formData[fieldComm]}
          ref={(el) => (mandatoryFieldRef.current[fieldComm] = el)}
          onChange={(e) => {
            resetIndvidualField(fieldComm);
            onHandleActionFieldsChange(e, "Comments");
          }}
          id="floatingTextarea"
        ></textarea>
        <label htmlFor="floatingTextarea">
          Comments
        </label>
      </div>
      <div className="d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap pt-2 pb-3">
        {!showCamera && !isView && (<input
          type="file"
          accept=".jpg, .jpeg, .png, .gif"
          onChange={handleFileChange}
          className="form-control"
          id="chooseFiles"
          style={{ display: "none"}}
          ref={(el) => (mandatoryFieldRef.current[fieldFile] = el)}
        />)}
        {!showCamera && !isView && <i
          className="fa-solid fa-upload fa-xl"
          title="Upload Photo"
          style={{ marginTop: "3px", cursor: "pointer" }}
          onClick={triggerFileInput}
        ></i>}
        {!showCamera && !isView && (
          <i
            className="fa-solid fa-camera fa-xl"
            onClick={() => setShowCamera(true)}
            title="Open Camera"
            style={{ marginTop: "3px", cursor: "pointer" }}
          ></i>
        )}
        {!isView && <i
          className="fa-solid fa-arrows-rotate fa-xl"
          onClick={handleReset}
          title="Reset"
          style={{ marginTop: "3px", cursor: "pointer" }}
        ></i>}
      </div>

      {showCamera && (
        <div>
          <Webcam
            audio={false}
            ref={webcamRef}
            height={280}
            screenshotFormat="image/jpeg"
            width={290}
            videoConstraints={videoConstraints}
          />
          <div className="d-flex flex-wrap gap-3 pb-2" style={{ justifyContent: "center" }}>
            <i
              className="fa-solid fa-camera fa-xl"
              onClick={capturePhoto}
              style={{ cursor: "pointer" }}
            ></i>
            <i
              className="fa-solid fa-camera-rotate fa-xl"
              onClick={switchCamera}
              style={{ cursor: "pointer" }}
            ></i>
            <i
              className="fa-solid fa-xmark fa-xl"
              onClick={closeCamera}
              style={{ cursor: "pointer" }}
              title="Close Camera"
            ></i>
          </div>
        </div>
      )}

      {capturedImages.length > 0 && (
        <div style={{ marginTop: "20px" }}>
          {/* <h4>Captured Images</h4> */}
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            {capturedImages.map((img, index) => (
              <div
                key={index}
                style={{
                  position: "relative",
                  display: "inline-block",
                  width: "200px",
                  border: "2px solid #000",
                }}
              >
                <img
                  src={img?.includes("data:image") ? img : ImageProxyBaseUrl + encodeURIComponent(img)}
                  alt={`Captured ${index + 1}`}
                  style={{ width: "100%", height: "auto", display: "block" }}
                />

                {!isView && <i
                  className="fa-solid fa-xmark"
                  onClick={() => setShowConfirmationPopup({
                      show: true,
                      itemIndex: index
                    })}
                  style={{
                    position: "absolute",
                    top: "5px",
                    right: "5px",
                    backgroundColor: "transparent",
                    color: "black",
                    border: "none",
                    borderRadius: "50%",
                    width: "24px",
                    height: "24px",
                    cursor: "pointer",
                  }}
                ></i>}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default MiniCapture;
